const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/portfolioassetlist/api-factory');
const serviceFactory = require('../resources/portfolioassetlist/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

//get sub assets list
  .match(`${p}portfolio.getAssetList[{keys:portfolioId}][{keys:asset}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getAssetList(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )))
  
  // WMCE-4443, BELOW PATHS CREATED TO MATCH PATHS FOR BP IDS AS BP ID WILL BE INTEGER, BP CONSOLIDATION
  .match(`${p}portfolio.getAssetList[{integers:portfolioId}][{keys:asset}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getAssetList(req.params)
       .then(response => res.value(response))
       .catch(res.error)
   )));
}

module.exports = addRoutes;
